import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Avatar,
  Rating,
} from "@mui/material";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    location: "Mumbai",
    rating: 5,
    review:
      "Absolutely in love with the necklace I ordered. The finish and shine are truly premium. It looks even more beautiful in real life!",
    avatar: "P",
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    location: "Delhi",
    rating: 5,
    review:
      "Bought a bracelet for my wife and she loved it. Elegant design, classy packaging, and quick delivery. Highly recommended!",
    avatar: "R",
  },
  {
    id: 3,
    name: "Ananya Patel",
    location: "Bangalore",
    rating: 5,
    review:
      "The craftsmanship is outstanding. You can truly feel the quality and attention to detail in every piece.",
    avatar: "A",
  },
];

const Testimonials = () => {
  return (
    <Box sx={{ py: 10, bgcolor: "#f9f6f2" }}>
      <Container maxWidth="lg">
        {/* Heading */}
        <Box sx={{ textAlign: "center", mb: 8 }}>
          <Typography
            variant="overline"
            sx={{ color: "#d4af37", fontWeight: 600, letterSpacing: 3 }}
          >
            CUSTOMER LOVE
          </Typography>

          <Typography
            variant="h4"
            sx={{ fontWeight: 700, color: "#000", mt: 2 }}
          >
            What Our Clients Say
          </Typography>
        </Box>

        {/* Testimonials Grid */}
        <Grid container spacing={4}>
          {testimonials.map((testimonial) => (
            <Grid item xs={12} md={4} key={testimonial.id}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  borderRadius: 4,
                  height: "100%",
                  position: "relative",
                  border: "1px solid #eee",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 15px 35px rgba(0,0,0,0.08)",
                  },
                }}
              >
                {/* Quote Icon */}
                <FormatQuoteIcon
                  sx={{
                    position: "absolute",
                    top: 16,
                    right: 16,
                    fontSize: 40,
                    color: "#f1e6c9",
                  }}
                />

                {/* Rating */}
                <Rating
                  value={testimonial.rating}
                  readOnly
                  size="small"
                  sx={{ mb: 2, color: "#d4af37" }}
                />

                {/* Review */}
                <Typography
                  variant="body1"
                  sx={{
                    color: "#555",
                    mb: 3,
                    lineHeight: 1.8,
                    fontStyle: "italic",
                  }}
                >
                  "{testimonial.review}"
                </Typography>

                {/* User Info */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Avatar
                    sx={{
                      bgcolor: "#000",
                      color: "#d4af37",
                      width: 50,
                      height: 50,
                      fontWeight: "bold",
                    }}
                  >
                    {testimonial.avatar}
                  </Avatar>

                  <Box>
                    <Typography
                      variant="subtitle1"
                      fontWeight="bold"
                      sx={{ color: "#000" }}
                    >
                      {testimonial.name}
                    </Typography>

                    <Typography variant="body2" sx={{ color: "#888" }}>
                      {testimonial.location}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Testimonials;
